// removed by extract-text-webpack-plugin
module.exports = {"root":"root___cAMvW"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Demo/StandardCRUD/Detail/Index.less
// module id = 5zzE
// module chunks = 31